const q = (u, t, i) => {
  var n;
  const s = u.find((m) => {
    var r;
    return ((r = m.info) == null ? void 0 : r.title) === "Drafts";
  }), f = t.length === 1;
  if (!t[0])
    return !1;
  const e = s == null ? void 0 : s.requests.includes(t[0]);
  if (!e)
    return !1;
  const g = ((n = i[(s == null ? void 0 : s.requests[0]) ?? ""]) == null ? void 0 : n.summary) !== "My First Request";
  return f && e && !g;
};
export {
  q as isGettingStarted
};
